import { Component, EventEmitter, Input, Output } from '@angular/core';

import {SelectCustomEvent} from '@ionic/angular';
@Component({
    selector: 'app-select-type-tracciato',
    templateUrl: './select-type-tracciato.component.html',
    styleUrls: ['./select-type-tracciato.component.scss'],
    standalone: false
})
export class SelectTypeTracciatoComponent {
  @Input() tracciatoType: number;
  @Output() tracciatoTypeChange = new EventEmitter<number>();
  public tracciatoTypes =
    [
      { value: 1, label: 'Scrittura' },
      { value: 2, label: 'Lettura' },
      { value: 3, label: 'Rimozione' }
    ];
  selectTracciatoType = (e: SelectCustomEvent) => this.tracciatoTypeChange.emit(+e.target.value);
}
